import { cx } from 'classix'

import styles from './Ctas.module.css'

interface TwoColumnsCtasWrapperProps {
	readonly children: React.ReactNode
	readonly absolute?: boolean
	readonly className?: string
}

export function TwoColumnsCtasWrapper({
	children,
	absolute = false,
	className,
}: TwoColumnsCtasWrapperProps) {
	return (
		<div className={cx(styles.ctasCenterWrapper, absolute && styles.absolute)}>
			<nav className={cx(styles.ctasWrapper, className)}>{children}</nav>
		</div>
	)
}
